import { withStyles } from '@material-ui/core/styles'
import MuiTextField from '@material-ui/core/TextField'
import MuiCheckbox from '@material-ui/core/Checkbox'
import MuiFormControlLabel from '@material-ui/core/FormControlLabel'
import MuiAutocomplete from '@material-ui/lab/Autocomplete'
import MuiFormLabel from '@material-ui/core/FormLabel'
import MuiFormControl from '@material-ui/core/FormControl'

export const TextField = withStyles((theme) => ({
  root: {
    margin: 0,
    '& .MuiOutlinedInput-root': {
      backgroundColor: theme.palette.common.white,
      borderColor: theme.palette.background.default,
      borderRadius: theme.shape.borderRadius * 1.5,
      '&.MuiAutocomplete-inputRoot': {
        paddingLeft: theme.spacing(1),
        paddingTop: 4,
        paddingBottom: 4
      }
    },
    '& .MuiFilledInput-root': {
      backgroundColor: theme.palette.background.default,
      borderColor: theme.palette.background.default,
      borderStyle: 'solid',
      borderWidth: 1,
      borderRadius: theme.shape.borderRadius * 1.5,
      '&.MuiFilledInput-underline': {
        '&::before, &::after': {
          display: 'none'
        }
      },
      '& .MuiAutocomplete-input': {
        padding: '4.5px 3px'
      }
    },
    '& .MuiInputBase-root': {
      '&.Mui-disabled': {
        backgroundColor: theme.palette.grey[100],
        borderColor: theme.palette.grey[100],
        '& .MuiInputBase-input': {
          color: theme.palette.grey[700]
        },
        '& .MuiOutlinedInput-notchedOutline': {
          borderColor: theme.palette.grey[100]
        }
      },
      '&:not(.Mui-disabled)': {
        '&:hover': {
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: theme.palette.inputs.border.primary
          }
        }
      },
      '&.Mui-focused, &.Mui-focused:hover': {
        '& .MuiOutlinedInput-notchedOutline': {
          borderColor: theme.palette.inputs.border.primary
        }
      },
      '&.Mui-error': {
        '& .MuiOutlinedInput-notchedOutline': {
          borderColor: theme.palette.error.light
        },
        '&:hover, &.Mui-focused, &.Mui-focused:hover': {
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: theme.palette.error.main
          }
        }
      }
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.inputs.border.primary
    },
    '& .MuiInputBase-input': {
      color: theme.palette.grey[900],
      fontWeight: 600,
      fontSize: '0.929rem',
      paddingTop: 8.5,
      paddingBottom: 8.5,
      height: '1em',
      '&.MuiInputBase-inputMultiline': {
        height: 'auto'
      },
      '&::-webkit-outer-spin-button, &::-webkit-inner-spin-button': {
        WebkitAppearance: 'none',
        margin: 0
      },
      '&[type="number"]': {
        MozAppearance: 'textfield'
      }
    },
    '& .MuiInputLabel-root': {
      color: theme.palette.inputs.label.color.dark,
      fontWeight: theme.palette.inputs.label.semibold,
      fontSize: '16px'
    },
    '& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
      transform: 'scale(0.75)',
      fontWeight: 600,
      paddingLeft: theme.spacing(1),
      position: 'relative'
    },
    '& .MuiFormLabel-asterisk': {
      color: theme.palette.error.light
    },
    '& .MuiFormHelperText-root': {
      margin: 0,
      lineHeight: 1,
      padding: theme.spacing(0.5, 0),
      '&:before': {
        position: 'absolute',
        content: '""',
        background: theme.palette.common.white,
        left: 0,
        right: 0,
        height: 2,
        top: 4,
        zIndex: -1
      }
    },
    '&.Mui-warning': {
      '& .MuiInputBase-root': {
        '& .MuiOutlinedInput-notchedOutline': {
          borderColor: theme.palette.warning.light
        },
        '&:hover, &.Mui-focused, &.Mui-focused:hover': {
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: theme.palette.warning.main
          }
        }
      },
      '& .MuiFormHelperText-root': {
        color: theme.palette.warning.main
      }
    },
    '& .MuiAutocomplete-endAdornment, & .MuiInputAdornment-positionEnd': {
      top: '50%',
      transform: 'translateY(-50%)',
      opacity: 0.75,
      '& .MuiIconButton-root': {
        padding: theme.spacing(0.5)
      },
      '& .MuiSvgIcon-root': {
        width: '0.75em',
        height: '0.75em'
      }
    }
  }
}))(MuiTextField)

export const NextTagAutocompleteTextField = withStyles((theme) => ({
  root: {
    '& .MuiOutlinedInput-root': {
      backgroundColor: theme.palette.common.white,
      borderRadius: theme.shape.borderRadius,
      padding: 0,
      '&.MuiAutocomplete-inputRoot': {
        paddingLeft: theme.spacing(1),
        paddingRight: theme.spacing(0.5)
      }
    },
    '& .MuiFilledInput-root': {
      backgroundColor: theme.palette.background.default,
      borderColor: theme.palette.background.default,
      borderStyle: 'solid',
      borderWidth: 1,
      borderRadius: theme.shape.borderRadius,
      '&.MuiFilledInput-underline': {
        '&::before, &::after': {
          display: 'none'
        }
      },
      '& .MuiAutocomplete-input': {
        padding: '4.5px 3px'
      }
    },
    '& .MuiInputBase-root': {
      '&:not(.Mui-disabled)': {
        '&:hover': {
          '& .MuiOutlinedInput-notchedOutline': {
            borderWidth: 0,
            borderBottom: `1px solid ${theme.palette.inputs.border.primary as string}`
          }
        }
      },
      '&.Mui-focused, &.Mui-focused:hover': {
        '& .MuiOutlinedInput-notchedOutline': {
          borderWidth: 0,
          borderBottom: `1px solid ${theme.palette.inputs.border.primary as string}`
        }
      }
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderWidth: 0,
      borderBottom: `1px solid ${theme.palette.inputs.border.primary as string}`
    },
    '& .MuiInputBase-input': {
      color: theme.palette.grey[900],
      fontWeight: 600,
      fontSize: '0.929rem',
      '&::-webkit-outer-spin-button, &::-webkit-inner-spin-button': {
        WebkitAppearance: 'none',
        margin: 0
      },
      '&[type="number"]': {
        MozAppearance: 'textfield'
      }
    },
    '& .MuiAutocomplete-endAdornment, & .MuiInputAdornment-positionEnd': {
      top: '50%',
      transform: 'translateY(-50%)',
      opacity: 0.75,
      '& .MuiIconButton-root': {
        padding: theme.spacing(0.5)
      },
      '& .MuiSvgIcon-root': {
        width: '0.75em',
        height: '0.75em'
      }
    }
  }
}))(MuiTextField)

export const Autocomplete = withStyles((theme) => ({
  root: {
    '& .MuiFormControl-root': {
      margin: 0
    }
  },
  option: {
    color: ({ greyresults }) => (greyresults === 'true' ? theme.palette.secondary.main : theme.palette.grey[900])
  },
  paper: {
    fontWeight: 600,
    fontSize: '0.929rem'
  },
  tag: {
    backgroundColor: theme.palette.grey[100],
    color: theme.palette.common.black,
    fontWeight: 600,
    fontSize: '0.87rem',
    borderRadius: theme.shape.borderRadius,
    margin: '1px'
  }
}))(MuiAutocomplete)

export const NextTagAutocomplete = withStyles((theme) => ({
  option: {
    color: theme.palette.grey[900]
  },
  paper: {
    fontWeight: 600,
    fontSize: '0.929rem',
    boxShadow: 'none',
    margin: 0,
    color: '#586069'
  },
  popperDisablePortal: {
    position: 'relative'
  }
}))(MuiAutocomplete)

export const FormControl = withStyles((theme) => ({
  root: {
    margin: 0,
    '& .Mui-focused': {
      color: theme.palette.inputs.label.color.dark
    }
  }
}))(MuiFormControl)

export const CheckboxLabel = withStyles((theme) => ({
  root: {
    marginLeft: 0
  },
  label: {
    fontSize: '0.929rem',
    color: theme.palette.inputs.label.color.light,
    paddingLeft: theme.spacing(0.5)
  }
}))(MuiFormControlLabel)

export const CheckboxGroupLabel = withStyles((theme) => ({
  root: {
    color: theme.palette.inputs.label.color.light,
    fontSize: '0.857rem',
    fontWeight: 600,
    paddingLeft: theme.spacing(1),
    '&.Mui-focused': {
      color: theme.palette.inputs.label.color.light
    }
  }
}))(MuiFormLabel)

export const Checkbox = withStyles(() => ({
  root: {
    padding: 4,
    marginLeft: -6
  }
}))(MuiCheckbox)

export const SmallCheckbox = withStyles(() => ({
  root: {
    padding: '1px'
  }
}))(MuiCheckbox)
